
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPriceOverrideReasonGrid extends Serenity.EntityGrid<PsPriceOverrideReasonRow, any> {
        protected getColumnsKey() { return PsPriceOverrideReasonColumns.columnsKey; }
        protected getIsActiveProperty() { return PsPriceOverrideReasonRow.isActiveProperty; } 
        protected getDialogType() { return PsPriceOverrideReasonDialog; }
        protected getIdProperty() { return PsPriceOverrideReasonRow.idProperty; }
        protected getInsertPermission() { return PsPriceOverrideReasonRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPriceOverrideReasonRow.localTextPrefix; }
        protected getService() { return PsPriceOverrideReasonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        //   protected getColumns() {
        //     var columns = super.getColumns();

            
    
        //     columns.unshift({
        //         id: 'Delete',
        //         field: null,
        //         name: '',
        //         cssClass: 'align-center',
        //         format: ctx => {
        //             return '<a class="inline-action" data-action="delete-row" title="Delete">'+
        //             '<i class="fa fa-trash-o text-red"></i></a>';
        //         },
        //         width: 36,
        //         minWidth: 36,
        //         maxWidth: 36
        //     });
    
        //     columns.splice(1, 0, {
        //         id: 'View Detail',
        //         field: null,
        //         name: '',
        //         cssClass: 'align-center',
        //         format: ctx => {
        //             return '<a class="inline-action" data-action="view-details" title="View Details">'+
        //             '<i class="fa fa-search text-blue"></i></a>';
        //         },
        //         width: 36,
        //         minWidth: 36,
        //         maxWidth: 36
        //     });
    
        //     return columns;
        // }
    
    

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
       
    
            var item = this.itemAt(row);
            let action = (e.target as HTMLElement)?.closest(".inline-action")?.getAttribute("data-action");
            
            if (action) {
                e.preventDefault();
                if (action == "view-details") {
                    this.editItem(item.PriceOverrideId);
                } else if (action == "delete-row") {

                    var Brandid = Q.tryFirst(PsPriceOverrideReasonRow.getLookup().items,x => x.PriceOverrideId == item.PriceOverrideId);
            if(Brandid != null){
              
                Q.warning("ข้อมูลนี้ไม่สามารถลบได้เนื่องจาก มีการใช้ข้อมูลอยู่")                
            }else{
                    Q.confirm('Delete record?', () => {
                        PsPriceOverrideReasonService.Delete({
                            EntityId: item.PriceOverrideId,
                        }, response => {
                            this.refresh();
                        });
                    });
                    }
                }
            }
        }
    }
}